import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessPipe } from './pipes/access.pipe';

@NgModule({
  declarations: [AccessPipe],
  imports: [CommonModule],
  exports: [AccessPipe]
})
export class RolesModule {}
